import { render, staticRenderFns } from "./Mounting.vue?vue&type=template&id=91dac67a&scoped=true&"
import script from "./Mounting.vue?vue&type=script&lang=js&"
export * from "./Mounting.vue?vue&type=script&lang=js&"
import style0 from "./Mounting.vue?vue&type=style&index=0&id=91dac67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dac67a",
  null
  
)

export default component.exports